<template>
    <div class="block-page-buttons">
        <div class="to-top item" v-if="showToTop" @click="toTop()">
            <img src="@/assets/img/top.png" />
        </div>
        <div class="calculator item" v-if="(calculator === '' || calculator === true)" @click="beforeToCalculator()">
            <img src="@/assets/img/calculator.png" />
        </div>
        <div class="store item" v-if="store == ''" @click="toPage('/appointment')">
            <img src="@/assets/img/store.png" />
        </div>
        <div class="person item" v-if="person == '' && customerServiceInfo.phone" @click="showUserInfo = !showUserInfo">
            <div class="pic"><img :src="$utils.setSourcePath(customerServiceInfo.headimg, 0)" /></div>
            <img class="phone" src="@/assets/img/phone2.png" />
        </div>

        <sd-mask v-if="showUserInfo" @click.native="showUserInfo = false;" class="person-info-mask">
            <div class="person-info" :style="setBgImg()" @click.stop>
                <div class="content">
                    <div class="top">
                        <div class="headimg">
                            <img :src="$utils.setSourcePath(customerServiceInfo.headimg, 0)" />
                        </div>
                        <div class="names">
                            <div class="name">
                                <div class="text">{{customerServiceInfo.first_name}} {{customerServiceInfo.last_name}}</div>
                                <div class="tag fundi">{{customerServiceInfo.position}}</div>
                            </div>
                            <div class="location">
                                <svg-icon icon-class="position"></svg-icon>
                                <div class="text">{{customerServiceInfo.level_name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="phone-number">+{{customerServiceInfo.area_code}}{{customerServiceInfo.phone}}</div>
                </div>
                <div class="phone-icon"><img @click="call()" src="@/assets/img/phone2.png" /></div>
            </div>
        </sd-mask>
    </div>
</template>

<script>
import SvgIcon from '../svgIcon.vue';
import sdMask from "./mask.vue";

export default {
    name: "float-buttons",
    components: { sdMask, SvgIcon },
    props: {
        product: String,
        top: Boolean,
        pageToTop: Boolean,
        calculator: String | Boolean,
        store: String,
        person: String,
        calculatorFun: String
    },
    data() {
        return {
            showUserInfo: false,
        }
    },
    computed: {
        showToTop() {
            return this.top
        },
        userinfo() {
            return this.$store.state.user.userinfo
        },
        isLogin() {
            return this.$store.getters.isLogin;
        },
        customerServiceInfo() {
            return this.$store.state.common.customerServiceInfo
        }
    },
    mounted() {
    },
    methods: {
        setBgImg() {
            return `background-image: url(${require("@/assets/img/userinfo_bg.png")})`
        },

        toTop() {
            this.$emit("toTop");
            if(this.pageToTop) return;
            var scrollToptimer = setInterval(function () {
                var top = document.body.scrollTop || document.documentElement.scrollTop;
                var speed = top < 10 ? top : top/4;
                if (document.body.scrollTop>0) {
                    document.body.scrollTop -= speed;
                }else {
                    document.documentElement.scrollTop -= speed;
                }
                if (top <= 0) {
                    clearInterval(scrollToptimer);
                }
            }, 30); 
        },

        call() {
            if(this.customerServiceInfo.phone) {
                window.location.href = `tel:${this.customerServiceInfo.area_code+this.customerServiceInfo.phone}`
            }
        },

        beforeToCalculator() {
            if(this.calculatorFun == '') {
                this.$emit("calculator");
            }else if(this.product) {
                if(!this.isLogin) return this.$utils.toLogin();
                this.$store.commit("changeLoading", this.$t('text.loading'));
                this.$apis.calculator.addCalculatorSideByProduct({
                    productId: this.product
                }).then(res => {
                    this.$store.commit("changeLoading", false);
                    this.toPage('/calculator');
                }).catch(err => {
                    this.$store.commit("changeLoading", false);
                })
            }else {
                this.toPage('/calculator');
            }
        },

        toPage(path, query) {
            this.$router.push({
                path, query
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.block-page-buttons {
    position: fixed;
    right: 12px;
    bottom: 94px;    
    z-index: 9;

    .item {
        width: 64px;
        height: 64px;
        margin-right: -8px;
    }

    .person {
        width: 48px;
        height: 48px;
        margin-top: 10px;
        margin-left: 8px;
        position: relative;

        .pic {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: white;
            box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 42px;
                height: 42px;
                border-radius: 50%;
                background: gray;
            }
        }

        .phone {
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: 20px;
            height: 20px;
        }
    }

    .person-info {
        width: 351px;
        height: 120px;
        position: absolute;
        bottom: 140px;
        left: 12px;
        display: flex;
        padding: 16px 18px 18px 16px;
        box-sizing: border-box;
        background-size: cover;
        background-repeat: no-repeat;

        .content {
            flex: 1;
            height: 100%;
            box-sizing: border-box;

            .top {
                display: flex;
                height: 48px;
                padding-bottom: 9px;

                .headimg {
                    width: 46px;
                    height: 46px;
                    overflow: hidden;
                    border-radius: 50%;
                    border: 1px solid white;
                }

                .names {
                    font-size: 14px;
                    margin-left: 12px;

                    .name {
                        display: flex;
                        margin: 2px 0;

                        .text {
                            flex: 1;
                            font-size: 20px;
                            line-height: 24px;
                            font-weight: bold;
                        }

                        .tag {
                            height: 19px;
                            position: relative;
                            top: 4px;
                            left: 6px;
                        }
                    }

                    .location {
                        display: flex;
                        font-size: 12px;
                        line-height: 18px;
                        color: #8F95A1;

                        .text {
                            flex: 1;
                            text-align: left;
                            margin-left: 4px;
                        }

                        .position {
                            top: 2px;
                            width: 14px;
                            height: 14px;
                            position: relative;
                        }
                    }
                }
            }

            .phone-number {
                text-align: left;
                width: 100%;
                padding-top: 9px;
                font-size: 16px;
                line-height: 19px;
                color: #8F95A1;
                border-top: 2px solid rgba(0, 0, 0, 0.05);
            }
        }

        .phone-icon {
            width: 55px;
            height: 55px;
            margin-top: 12px;
            margin-left: 20px;
        }
    }

    .person-info-mask {
        z-index: 99;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/floatButton.vue